import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { SectionScrollModelProvider } from '@/components/common/context/SectionScrollModelProvider';
import { LandingContent } from '@/components/landing/LandingContent';
import { useUrlWithQueryString } from '@/lib/hooks/use-url-with-query-string';

const RedirectPage = () => {
  const router = useRouter();
  const redirectUrl = useUrlWithQueryString('/');

  useEffect(() => {
    if (redirectUrl) {
      router.push(redirectUrl);
    }
  }, [redirectUrl, router]);

  return (
    <SectionScrollModelProvider>
      <LandingContent />
    </SectionScrollModelProvider>
  );
};

export default RedirectPage;
